import Hub from '../hub.js';
import { LocalStorageManager } from '../utils/storage-manager.js'

const LikeCounter = (() => {

    const Options = {
        STORAGE: 'likeCounter',
        SELECTOR: {
            COUNTER: '.js-like-counter',
        },
        ATTR: {
            COUNTER: 'data-like-counter',
        },
        CLASSNAMES: {
            ACTIVE: 'is-active'
        },
        TYPE: {
            PRODUCT: 'products'
        }
    };

    class LikeCounter {
        constructor() {
            this.counter = 0;
            this.storageManager = new LocalStorageManager(Options.STORAGE);
            this.subscribe();
            this.initCounter();
        }

        initCounter() {
            const counter = this.storageManager.getItem();

            if (counter === null) {
                this.storageManager.setItem(this.counter);
            } else {
                this.counter = counter;
            }

            this.update();
        }

        update() {
            try {
                const storageCounter = this.storageManager.getItem();
                const counter = storageCounter > 9 ? '9+' : storageCounter;

                document.querySelectorAll(Options.SELECTOR.COUNTER).forEach($el => {
                    $el.setAttribute(Options.ATTR.COUNTER, counter);
                    if (storageCounter > 0) {
                        $el.classList.add(Options.CLASSNAMES.ACTIVE);
                    } else {
                        $el.classList.remove(Options.CLASSNAMES.ACTIVE);
                    }
                });
            } catch (e) {
                return 0;
            }
        }

        handleLike(model) {
            if (model.type === Options.TYPE.PRODUCT) {
                this.counter++;
                this.storageManager.setItem(this.counter);
                this.update();
            }
        }

        handleUnlike(model) {
            if (model.type === Options.TYPE.PRODUCT) {
                this.counter > 0 ? this.counter -= 1 : this.counter = 0;
                this.storageManager.setItem(this.counter);
                this.update();
            }
        }

        subscribe() {
            Hub.subscribe(Hub.LIKE_ADD, this.handleLike.bind(this));
            Hub.subscribe(Hub.LIKE_REMOVE, this.handleUnlike.bind(this));
            Hub.subscribe(Hub.HTML_UPDATE, this.update.bind(this));
        }
    }

    return new LikeCounter();

})();

export default LikeCounter;
